import { render } from "./DialogBase.vue?vue&type=template&id=4797dc68&scoped=true"
import script from "./DialogBase.vue?vue&type=script&lang=js"
export * from "./DialogBase.vue?vue&type=script&lang=js"

import "./DialogBase.vue?vue&type=style&index=0&id=4797dc68&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4797dc68"]])

export default __exports__